import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import VueRouter from "vue-router";

import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin, AmplifyEventBus } from "aws-amplify-vue";
Vue.use(AmplifyPlugin, AmplifyModules);
import aws_exports from "@/aws-exports";
Amplify.configure(aws_exports);

// Vuex
import store from "@/store";

// router setup
import routes from "./router/routes";
Vue.use(VueRouter);
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active",
});

Vue.config.productionTip = false;

import VueAnalytics from "vue-analytics";
Vue.use(VueAnalytics, {
  id: "UA-263284936-1",
  router,
});

// Sweetalert
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

new Vue({
  render: (h) => h(App),
  store,
  router,

  methods: {
    updateUser() {
      AmplifyModules.Auth.currentAuthenticatedUser()
        .then((user) => {
          store.commit("settings/changeAuth", {
            authenticated: true,
            user: user,
          });
        })
        .catch(() => {
          // pass
        });
    },
  },

  beforeMount() {
    AmplifyEventBus.$on("authState", (event) => {
      if (event === "confirmSignUp") {
        // A user has been added
        store.commit("settings/userAdded");
      }
      this.updateUser();
      if (event === "signedIn") store.commit("settings/toggleAuthModal", false);
    });
    this.updateUser();
  },
}).$mount("#app");
